var OfferManager = function() {
    var that = this;

    that.showReactivationModal = function() {
        // hide all other modals first, other-wise they might appear on top of the offer

        $(".modal").each(function () {
            $(this).modal("hide");
        });

        $("#reactivation-offer-modal").modal("show");


    };

    that.requestExport = function(afterSuccessFunc, upgradeUrl, checkOnly, search) {
        var paramStr = search || window.location.search.substr(1);
        if (checkOnly) {
            paramStr += "&check_only=1";
        }

        if (window.exportURL && window.exportURL.includes('force_download=1')) {
          paramStr += "&force_download=1";
        }
        if (paramStr.indexOf('?') === 0) {
            paramStr = paramStr.substring(1);
        }
        $.post("/_api/requestExport.php", paramStr, function(resp) {
            if (resp.allow_export) {
                afterSuccessFunc();
            } else {
                if (resp.next_action == 'show_reactivation_modal') {
                    that.showReactivationModal();
                }
                else {
                    window.location = upgradeUrl;
                }
            }
        });
    };

    that.applyReactivationOffer = function(showOfferOn) {
        $(showOfferOn).each(this.addReactivationOfferClickEvent);
    };

    that.addReactivationOfferClickEvent = function () {

        // We don't want any other onclick events firing, remove them then add our own.
        $(this).prop('onclick', null);
        $(this).attr("href", "#");

        $(this).click(function(e) {
            that.showReactivationModal();
            e.preventDefault();
            return false;
        });


    };

};

module.exports = OfferManager;



// WEBPACK FOOTER //
// ./src-assets/js/offer-manager.js